/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Retail {

    import fld = GiftVoucherItemDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class GiftVoucherItemDetailsEditor extends Common.GridEditorBase<GiftVoucherItemDetailsRow> {


        protected getColumnsKey() { return "Retail.GiftVoucherItemDetails"; }
        protected getDialogType() { return GiftVoucherItemDetailsDialog; }
        protected getLocalTextPrefix() { return GiftVoucherItemDetailsRow.localTextPrefix; }
        protected form: GiftVoucherItemDetailsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        constructor(container: JQuery) {
            super(container);

        }
        protected getButtons() {
            let buttons = super.getButtons();
            buttons.pop();
            return buttons;
        }

        public emptygrid() {
            this.setItems([]);
            this.view.refresh();
        }
        public setValue(quantity: number, value: number, code: string, mininvoice: number, giftid: number) {

            var Config = Q.deepClone(q.Config);

            Config.count = quantity;
            Config.length = 16;
            Config.charset = "0123456789"
            Config.pattern = "####-####-####-####";

            var Codes = q.CodeGenerate(Config);

            var MasterCode = OMS.GiftVoucherMasterRow.getLookup().itemById[giftid];

            for (var i = 0; i < Codes.length; i++) {
                var item: GiftVoucherItemDetailsRow = {

                    UniqueNo: Codes[i],
                    GiftMasterId: giftid,
                    Value: value,
                    MinInvoiceValue: mininvoice,
                    Code: MasterCode.Code,
                    FixedName: MasterCode.FixedName
                };
                item[this.getIdProperty()] = "`" + this.nextId++;
                
                this.view.addItem(item);
            }

        }

    }
}